import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";
import React from "react";
import { createRoot } from "react-dom/client";
import pageTemplate from "text!../../../templates/settingsPage/SettingsPage2Template.html";
import SettingsPage from "../../components/settings/SettingsPage";
import ti18n from "i18n!nls/SettingsPagei18n";

const SettingsPage2View = Backbone.View.extend({
  template: _.template(pageTemplate),

  pageName: "Settings",

  events: {
    "click #homeHeaderButton": "onHomeButtonSelected",
  },

  initialize: function (options) {
    this._reactRoot = null;
    this._userInfo = options ? options.userInfo : null;
    this._workspace = options ? options.workspace : null;
    this._userRole = options ? options.userRole : null;
    this._members = options ? options.members : [];
    this._reviewers = options ? options.reviewers : [];
    this._callbacks = options ? options.callbacks : {};
    this._initialPushNotificationsEnabled = options ? !!options.initialPushNotificationsEnabled : false;
    this._initialEmailNotificationsEnabled = options ? !!options.initialEmailNotificationsEnabled : false;
    this._controlledSection = null;
  },

  onHomeButtonSelected: function () {
    this.trigger("showHomePopup");
  },

  updateUserInfo: function (userInfo) {
    this._userInfo = userInfo;
    this._renderSettingsPage();
  },

  updateWorkspaceData: function (workspace, userRole, members, reviewers) {
    this._workspace = workspace;
    this._userRole = userRole;
    this._members = members;
    this._reviewers = reviewers || [];
    this._renderSettingsPage();
  },

  _onPageShow: function () {
    this.trigger("pageshow");
    // Apply any pending section navigation (e.g. from "Team Members" hamburger button)
    if (window._pendingSettingsSection) {
      this._controlledSection = window._pendingSettingsSection;
      window._pendingSettingsSection = null;
      this._renderSettingsPage();
    }
  },

  _onPageHide: function () {
    this.trigger("pagehide");
  },

  _onPageRemoved: function () {
    if (this._reactRoot) {
      this._reactRoot.unmount();
      this._reactRoot = null;
    }
    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.stopListening();
  },

  _renderSettingsPage: function () {
    var reactContainer = this.$el.find("#settingsReactRoot").get(0);
    if (!reactContainer) return;

    if (!this._reactRoot) {
      this._reactRoot = createRoot(reactContainer);
    }

    var controlledSection = this._controlledSection;
    this._controlledSection = null;
    this._reactRoot.render(
      React.createElement(SettingsPage, {
        userInfo: this._userInfo,
        workspace: this._workspace,
        userRole: this._userRole,
        members: this._members,
        reviewers: this._reviewers,
        onEditProfile: this._callbacks.onEditProfile,
        onChangePassword: this._callbacks.onChangePassword,
        onChangeProfilePicture: this._callbacks.onChangeProfilePicture,
        onLogout: this._callbacks.onLogout,
        onTogglePushNotifications: this._callbacks.onTogglePushNotifications,
        onToggleEmailNotifications: this._callbacks.onToggleEmailNotifications,
        onInviteMember: this._callbacks.onInviteMember,
        onRemoveMember: this._callbacks.onRemoveMember,
        onRemoveReviewer: this._callbacks.onRemoveReviewer,
        onSetMemberRole: this._callbacks.onSetMemberRole,
        onLeaveWorkspace: this._callbacks.onLeaveWorkspace,
        onDeleteWorkspace: this._callbacks.onDeleteWorkspace,
        onUpgradePlan: this._callbacks.onUpgradePlan,
        onUpdatePaymentMethod: this._callbacks.onUpdatePaymentMethod,
        onChangePlan: this._callbacks.onChangePlan,
        onCancelSubscription: this._callbacks.onCancelSubscription,
        onPurchaseHourPack: this._callbacks.onPurchaseHourPack,
        initialPushNotificationsEnabled: this._initialPushNotificationsEnabled,
        initialEmailNotificationsEnabled: this._initialEmailNotificationsEnabled,
        i18nModule: ti18n,
        controlledSection: controlledSection,
      })
    );
  },

  render: function () {
    this.$el.html(this.template({ ti18n: ti18n }));
    this.setElement(this.$el.find("div").first());
    this.$el.page();

    // Mount React component
    this._renderSettingsPage();

    // Manually wrap for JQM panel support
    this.$el
      .children(
        ".ui-header:not(.ui-header-fixed), .ui-content:not(.ui-popup), .ui-footer:not(.ui-footer-fixed)"
      )
      .wrapAll("<div class='ui-panel-wrapper'></div>");

    this.$el.on("pageshow", this._onPageShow.bind(this));
    this.$el.on("pagehide", this._onPageHide.bind(this));
    this.$el.on("pageremove", this._onPageRemoved.bind(this));

    return this;
  },
});

export default SettingsPage2View;
